import { render, staticRenderFns } from "./PurchaseButton.vue?vue&type=template&id=034752e4&"
var script = {}
import style0 from "./PurchaseButton.vue?vue&type=style&index=0&id=034752e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports